export const MATRIX = {
  // height: 700,
  scale: 1,
  breakpoints: {
    5000: {
      height: 954,
      // scale: 0.9,
    },
    2325: {
      height: 846,
    },
    2199: {
      height: 588,
    },
    1920: {
      height: 588,
      // scale: 1,
    },
    1500: {
      height: 588,
      scale: 0.63,
    },
    1300: {
      height: 588,
      scale: 0.63,
    },
    // 1050: {
    //   height: 640,
    //   scale: 0.7,
    // },
    640: {
      height: 588,
      scale: 0.59,
    },
    400: {
      height: 588,
      scale: 0.47,
    },
  },
};

export const MATRIX_TABLE = {
  // height: 700,
  scale: 1,
  breakpoints: {
    750: {
      height: 588,
      scale: 0.73,
    },
    510: {
      height: 588,
      scale: 0.65,
    },
    442: {
      height: 588,
      scale: 0.57,
    },
  },
};

export const MATRIX_MODAL = {
  // height: 700,
  scale: 0.95,
  breakpoints: {
    5000: {
      height: 954,
    },
    2199: {
      height: 588,
      // scale: 0.9,
    },
    1920: {
      height: 588,
      // scale: 0.8,
    },
    1100: {
      height: 588,
      scale: 0.95,
    },
    750: {
      height: 588,
      scale: 0.83,
    },
    620: {
      height: 588,
      scale: 0.73,
    },
    560: {
      height: 588,
      scale: 0.63,
    },
    490: {
      height: 588,
      scale: 0.53,
    },
    425: {
      height: 588,
      scale: 0.43,
    },
  },
};
// (matrix, scale)
export const getBreakpoints = (elem, attrName, windowWidth) => {
  let prev = 0;
  let result = elem[attrName];
  if (elem.breakpoints != null) {
    Object.keys(elem.breakpoints).forEach((breakpointsWidth) => {
      if (windowWidth <= +breakpointsWidth && windowWidth > prev) {
        if (elem.breakpoints[breakpointsWidth][attrName]) {
          result = elem.breakpoints[breakpointsWidth][attrName];
        }
        prev = breakpointsWidth;
      }
    });
  }
  return result;
};
